import React from 'react'

const WealthMethodDBCUpsell = () => {
  return (
    <div>WealthMethodDBCUpsell</div>
  )
}

export default WealthMethodDBCUpsell